import React from 'react'
import { string } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import Articles from 'components/organisms/Articles'
import ActionTypeProp from 'utils/prop_types/ActionTypeProp'

const SectionRelatedArticles = ({ sourceUrl, type }) => (
  <SectionContainer id="related-articles">
    <Articles
      sectionTitle="Artikel Terkait"
      sourceUrl={sourceUrl}
      className="related-articles-section"
      type={type}
      global
    />
    <style jsx>
      {`
        :global(.related-articles-section) {
          padding-top: 0px !important;
        }
        :global(.ThumbnailSlider) {
          margin: 0 !important;
        }
      `}
    </style>
  </SectionContainer>
)

SectionRelatedArticles.propTypes = {
  sourceUrl: string,
  type: ActionTypeProp,
}

export default SectionRelatedArticles
